'use strict';

angular.module('ClinicApp').controller('BillingContested', function($scope, $modalInstance, appointment, GrowlService, refreshAppointments, AppointmentService, BillingContestedConstants, ClinicConfig) {
  $scope.config = ClinicConfig;
  $scope.appointment = appointment;
  $scope.isContested = _.get(appointment, 'metadata.billingContested') == BillingContestedConstants.CONTESTED;
  $scope.reason = $scope.isContested ? _.get(appointment, 'metadata.billingContestedReason', '') : '';
  $scope.reasonOther = '';

  const allReasonOptions = Object.values(BillingContestedConstants.REASONS);
  const isCDCP = appointment.insuranceData?.provider === BillingContestedConstants.INSURANCE_PROVIDERS.CDCP;

  // The "social assistance" reason is not a valid contest reason under the
  // Canadian Dental Care Plan (CDCP), so hide it for CDCP appointments.
  $scope.reasonOptions = isCDCP
    ? allReasonOptions.filter((option) => option !== BillingContestedConstants.REASONS.SOCIAL_ASSISTANCE)
    : allReasonOptions;

  $scope.otherReasonSelected = function() {
    return $scope.reason === BillingContestedConstants.REASONS.OTHER;
  };

  $scope.getReason = function() {
    return $scope.otherReasonSelected() ? $scope.reasonOther : $scope.reason;
  };

  $scope.submitModal = function() {
    AppointmentService.updateBillingContested(
      appointment.id,
      BillingContestedConstants.CONTESTED,
      $scope.getReason(),
    ).then(function() {
      refreshAppointments();
      GrowlService.success('Your request has been submitted.');
      $modalInstance.close();
    });
  };
});
